import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import ApplyToJoin from './pages/ApplyToJoin';
import AdminDashboard from './pages/AdminDashboard';
import AdminVerify from './pages/AdminVerify';
import DigitalMemberCard from './pages/DigitalMemberCard';
import MemberVerify from './pages/MemberVerify';
import AreaHeadSOS from './pages/AreaHeadSOS';
import MyProfile from './pages/MyProfile';
import AdminMembers from './pages/AdminMembers';
import HelpRequest from './pages/HelpRequest';
import HelpQueue from './pages/HelpQueue';
import Community from './pages/Community';
import Volunteer from './pages/Volunteer';
import Jobs from './pages/Jobs';
import Talent from './pages/Talent';
import LocalBusiness from './pages/LocalBusiness';
import { UpdateBanner } from './components/InstallApp';
import { applyUpdate } from './utils/pwa';

function App() {
  return (
    <BrowserRouter>
      <UpdateBanner onReload={applyUpdate} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/apply" element={<ApplyToJoin />} />
        <Route element={<MainLayout />}>
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={['Admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/verify"
            element={
              <ProtectedRoute roles={['Admin']}>
                <AdminVerify />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members"
            element={
              <ProtectedRoute roles={['Admin']}>
                <AdminMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/card"
            element={
              <ProtectedRoute>
                <DigitalMemberCard />
              </ProtectedRoute>
            }
          />
          <Route path="/verify/:memberId" element={<MemberVerify />} />
          <Route
            path="/community"
            element={
              <ProtectedRoute>
                <Community />
              </ProtectedRoute>
            }
          />
          <Route
            path="/community/:memberId"
            element={
              <ProtectedRoute>
                <Community />
              </ProtectedRoute>
            }
          />
          <Route
            path="/volunteer"
            element={
              <ProtectedRoute>
                <Volunteer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/talent"
            element={
              <ProtectedRoute>
                <Talent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business"
            element={
              <ProtectedRoute>
                <LocalBusiness />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <HelpRequest />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help/queue"
            element={
              <ProtectedRoute roles={['Admin', 'Area Head']}>
                <HelpQueue />
              </ProtectedRoute>
            }
          />
          <Route
            path="/area-head/sos"
            element={
              <ProtectedRoute roles={['Admin', 'Area Head']}>
                <AreaHeadSOS />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
